import { render, staticRenderFns } from "./link_order.vue?vue&type=template&id=9da6f2ce&"
import script from "./link_order.vue?vue&type=script&lang=js&"
export * from "./link_order.vue?vue&type=script&lang=js&"
import style0 from "./link_order.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports